import React, { useEffect, useState } from "react";
import axios from "axios";
import { FileText, Download } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const DocumentsSection = () => {
    const [docs, setDocs] = useState([]);
    useEffect(() => {
        axios.get(`${API}/documents`).then(r => setDocs(r.data)).catch(() => {});
    }, []);
    if (!docs.length) return null;
    return (
        <section className="py-16 px-4 bg-[#F5EDD6]" data-testid="documents-section">
            <div className="max-w-4xl mx-auto">
                <span className="font-marker text-[#C4522A] text-2xl -rotate-1 inline-block mb-2">Resources</span>
                <h2 className="font-anton text-4xl text-[#3D2008] uppercase mb-8">Documents &amp; Downloads</h2>
                <div className="space-y-3">
                    {docs.map(d => (
                        <a key={d.id} href={`${process.env.REACT_APP_BACKEND_URL}${d.url}`} target="_blank" rel="noopener noreferrer"
                            data-testid={`public-doc-${d.id}`}
                            className="flex items-center gap-4 bg-white border-2 border-[#3D2008] p-4 shadow-[3px_3px_0px_0px_rgba(61,32,8,0.2)] hover:translate-x-[2px] hover:translate-y-[2px] hover:shadow-none transition-transform">
                            <FileText size={22} className="text-[#C4522A] flex-shrink-0" />
                            <div className="flex-1 min-w-0">
                                <p className="font-anton text-[#3D2008] uppercase">{d.title}</p>
                                {d.description && <p className="font-manrope text-sm text-[#5C4A35]">{d.description}</p>}
                            </div>
                            <Download size={18} className="text-[#2D5A27] flex-shrink-0" />
                        </a>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DocumentsSection;
